module.exports = __webpack_public_path__ + "img/cancel_32.ceab4ccc.svg";